import { VendorUpdatePage } from '@/features/vendor/pages/VendorUpdate'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/vendor/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["vendor.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VendorUpdatePage,
})
